import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

import { MARKET_PLACE } from "src/constants/routes";
import { replaceFloatValue } from "utils/replaceFloatValue";

const PieData = ({ range, price, preSaleStarted }) => (
  <div className="d-flex justify-content-between px-3 align-items-center">
    <div className="key mb-1">{range}</div>
    <div className="value mb-1 text-center">
      <p className="text-white mb-1">{price}</p>
    </div>
  </div>
);

const PieChart = ({ preSaleStarted, checkPreSaleEndDate }) => {
  const navigate = useNavigate();

  //icx price in usd
  const icxInUSD = useSelector((state) => state.icxPricing.price);

  const handleRedirection = () => {
    navigate(MARKET_PLACE.INDEX);
  };

  return (
    <div className="pie-chart">
      {!preSaleStarted ? (
        <div className="pb-0">
          <p className="title mb-0 pb-2">Pre-sale hasn't started</p>
          <p className="description mb-1">
            Follow us for more updates about the presale <br /> and give aways.
          </p>
        </div>
      ) : (
        <>
          {!checkPreSaleEndDate ? (
            <div className="row d-flex pt-2">
              <p className="description mt-30 pb-2">
                <strong>Pre-sale of GangstaBet has started.</strong> To ensure a
                fair distribution, participants will not know their characters
                when they buy.
              </p>
              <p className="description mt-30 pb-2">
                <strong>
                  During pre-sale, you will receive $GBET 3060 tokens that can
                  be used to increase the stats of your GangstaBets.
                </strong>
              </p>
            </div>
          ) : (
            <div className="row d-flex pt-2">
              <p className="description mt-30 pb-2">
                <strong>Sale of GangstaBet is live.</strong>
              </p>
              <p className="description mt-30 pb-2">
                To ensure a fair distribution, participants will not know their
                characters when they buy. During sale, you will receive $GBET
                2460 tokens that can be used to increase the stats of your
                GangstaBets.
              </p>
            </div>
          )}

          {/* <div className="pb-0">
            <button
              className="btn explore-button mb-1 mt-2"
              onClick={handleRedirection}
            >
              Explore Market Place{" "}
              <BsArrowRight className="arrow" color="white" />
            </button>
          </div> */}
        </>
      )}
    </div>
  );
};

export default PieChart;
